import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormBuilder,FormGroup } from '@angular/forms';
import { ProductosProvider } from '../../providers/productos/productos'

@IonicPage()
@Component({
  selector: 'page-imagenes',
  templateUrl: 'imagenes.html',
})
export class ImagenesPage {
  @ViewChild('fileInputIngles') fileInputIngles

  form: FormGroup;
  todo:any
  listaCopia:any
  lista:any
  constructor(public navCtrl: NavController, public navParams: NavParams, formBuilder: FormBuilder,
    public servicio:ProductosProvider) {

    this.form = formBuilder.group({

    profilePicIngles: ['']

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ImagenesPage');
  }

  submit(form:any){
    let valores = ""
    console.log(this.todo)
  }


  processWebImageIngles(event) {

    let reader = new FileReader();
    reader.onload = (readerEvent) => {

      let imageData = (readerEvent.target as any).result;
      this.form.patchValue({ 'profilePicIngles': imageData });
    };

    reader.readAsDataURL(event.target.files[0]);
  }

  getProfileImageStyle(valor) {
      return 'url(' + this.form.controls['profilePic'].value + ')'
  }

  getProfileImageStyles(valor) {
      return 'url(' + this.form.controls['profilePicIngles'].value + ')'
  }
  getPictureIngles() {
    this.fileInputIngles.nativeElement.click();
    // if (Camera['installed']()) {
    //   this.camera.getPicture({
    //     destinationType: this.camera.DestinationType.DATA_URL,
    //     targetWidth: 96,
    //     targetHeight: 96
    //   }).then((data) => {
    //     this.form.patchValue({ 'profilePicIngles': 'data:image/jpg;base64,' + data });
    //   }, (err) => {
    //     alert('Unable to take photo');
    //   })
    // } else {
    //   this.fileInputIngles.nativeElement.click();
    // }
  }

  createItem(){
    let imagen = this.form.controls['profilePicIngles'].value
    let profilePicIngles = this.form.controls['profilePicIngles'].value
    // this.servicio.guardarmio(this.form,profilePicIngles)
  }

  verificarDatos(val:any){


  }


}



// WEBPACK FOOTER //
// ./src/pages/imagenes/imagenes.ts